import { TabsBase } from "./app.tabs-base.js";

var TABLET_QUERY = "(max-width: 1024px)";

var product_tabs_default = (() => {
    if (customElements.get("product-tabs")) return;
    customElements.define("product-tabs", class ProductTabs extends TabsBase {
        constructor() {
            super();
            this.onResize = this.onResize.bind(this);
            this.animating = false;
            this.activeTab = null;
            this.activePanel = null;
        }
        connectedCallback() {
            super.connectedCallback();
            window.addEventListener("resize", this.onResize);
            this.panelsWrapper = this.querySelector("[data-panels-wrapper]");
            if (!this.panelsWrapper) return;
            this.activeTab = this.querySelector('[role="tab"][aria-selected="true"]');
            if (!this.activeTab && window.matchMedia(TABLET_QUERY).matches) {
                this.activeTab = this.querySelector('[role="tab"]');
                if (this.activeTab) this.activeTab.setAttribute("aria-selected", "true");
            }
            if (this.activeTab) {
                this.activePanel = this.getPanelFor(this.activeTab);
                if (this.activePanel) {
                    this.setFlow(this.activePanel, true);
                    this.activePanel.setAttribute("aria-hidden", "false");
                    this.activePanel.style.opacity = "1";
                    this.activePanel.style.visibility = "visible";
                    this.activePanel.style.pointerEvents = "auto";
                    requestAnimationFrame(() => {
                        this.panelsWrapper.style.maxHeight = `${this.activePanel.offsetHeight}px`;
                    });
                } else this.panelsWrapper.style.maxHeight = "0px";
            } else this.panelsWrapper.style.maxHeight = "0px";
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            window.removeEventListener("resize", this.onResize);
        }
        onResize() {
            if (this.animating || !this.activePanel || !this.panelsWrapper) return;
            requestAnimationFrame(() => {
                if (this.animating || !this.activePanel || !this.panelsWrapper) return;
                this.panelsWrapper.style.maxHeight = `${this.activePanel.offsetHeight}px`;
            });
        }
        requestActivation(tab) {
            this.toggleTab(tab);
        }
        get prefersReducedMotion() {
            return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        }
        getPanelFor(tab) {
            const panelId = tab.getAttribute("aria-controls");
            return panelId ? this.getPanel(panelId) : null;
        }
        setTabState(tabs, clickedTab, activeTab) {
            tabs.forEach(current => {
                const selected = activeTab != null && current === activeTab;
                current.setAttribute("aria-selected", selected ? "true" : "false");
                current.setAttribute("tabindex", current === clickedTab ? "0" : "-1");
            });
        }
        showPanel(panel) {
            panel.style.visibility = "visible";
            panel.style.pointerEvents = "auto";
            panel.setAttribute("aria-hidden", "false");
            panel.offsetHeight;
            panel.style.opacity = "1";
        }
        hidePanel(panel) {
            panel.style.pointerEvents = "none";
            panel.setAttribute("aria-hidden", "true");
            panel.style.opacity = "0";
        }
        finalizeHidden(panel) {
            panel.style.visibility = "hidden";
        }
        setFlow(panel, on) {
            if (on) panel.setAttribute("data-flow", "true"); else panel.removeAttribute("data-flow");
        }
        async toggleTab(tab) {
            if (this.animating || !this.panelsWrapper) return;
            const tabs = this.getTabsFor(tab);
            if (tabs.length === 0) return;
            const shouldActivate = !(tab.getAttribute("aria-selected") === "true");
            const targetPanel = shouldActivate ? this.getPanelFor(tab) : null;
            const currentPanel = this.activePanel;
            this.setTabState(tabs, tab, shouldActivate ? tab : null);
            if (this.prefersReducedMotion) {
                this.applyInstantState(currentPanel, targetPanel);
                this.activeTab = shouldActivate ? tab : null;
                this.activePanel = targetPanel;
                return;
            }
            this.animating = true;
            try {
                if (!currentPanel && targetPanel) await this.animateOpen(targetPanel); else if (currentPanel && !targetPanel) await this.animateCollapse(currentPanel); else if (currentPanel && targetPanel && currentPanel !== targetPanel) await this.animateSwitch(currentPanel, targetPanel);
                this.activeTab = shouldActivate ? tab : null;
                this.activePanel = targetPanel;
            } finally {
                this.animating = false;
            }
        }
        applyInstantState(currentPanel, targetPanel) {
            if (currentPanel && currentPanel !== targetPanel) {
                currentPanel.setAttribute("aria-hidden", "true");
                currentPanel.style.opacity = "0";
                currentPanel.style.visibility = "hidden";
                currentPanel.style.pointerEvents = "none";
                this.setFlow(currentPanel, false);
            }
            if (targetPanel) {
                this.setFlow(targetPanel, true);
                targetPanel.setAttribute("aria-hidden", "false");
                targetPanel.style.opacity = "1";
                targetPanel.style.visibility = "visible";
                targetPanel.style.pointerEvents = "auto";
                this.panelsWrapper.style.maxHeight = `${targetPanel.offsetHeight}px`;
            } else this.panelsWrapper.style.maxHeight = "0px";
        }
        async animateOpen(targetPanel) {
            this.setFlow(targetPanel, true);
            this.panelsWrapper.style.maxHeight = `${targetPanel.offsetHeight}px`;
            this.showPanel(targetPanel);
            await this.waitForTransition(targetPanel, "opacity");
        }
        async animateCollapse(currentPanel) {
            this.hidePanel(currentPanel);
            await this.waitForTransition(currentPanel, "opacity");
            this.finalizeHidden(currentPanel);
            this.setFlow(currentPanel, false);
            this.panelsWrapper.style.maxHeight = "0px";
        }
        async animateSwitch(currentPanel, targetPanel) {
            this.hidePanel(currentPanel);
            await this.waitForTransition(currentPanel, "opacity");
            this.finalizeHidden(currentPanel);
            this.setFlow(currentPanel, false);
            this.setFlow(targetPanel, true);
            this.panelsWrapper.style.maxHeight = `${targetPanel.offsetHeight}px`;
            this.showPanel(targetPanel);
            await this.waitForTransition(targetPanel, "opacity");
        }
        waitForTransition(el, property) {
            return new Promise(resolve => {
                let done = false;
                const finish = () => {
                    if (done) return;
                    done = true;
                    el.removeEventListener("transitionend", onEnd);
                    clearTimeout(timer);
                    resolve();
                };
                const onEnd = event => {
                    if (event.target !== el || event.propertyName !== property) return;
                    finish();
                };
                const timer = setTimeout(finish, 600);
                el.addEventListener("transitionend", onEnd);
            });
        }
    });
})();